import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LandingPage from './pages/Landing';
import ApplicationWizard from './pages/ApplicationWizard';
import PricingMethodology from './pages/PricingMethodology';
import PortalAdmin from './pages/PortalAdmin';
import FAQs from './pages/FAQs';
import Login from './pages/Login';
import { LegalPage, TermsContent, PrivacyContent, StewardshipContent, DisputesContent } from './pages/LegalContent';

const App: React.FC = () => {
  const [user, setUser] = useState<{ phone: string; role: string; name: string } | null>(null);

  useEffect(() => {
    const saved = localStorage.getItem('chui_user');
    if (saved) setUser(JSON.parse(saved));
  }, []);

  const handleLogin = (phone: string, name: string, role: string) => {
    const userData = { phone, name, role };
    setUser(userData);
    localStorage.setItem('chui_user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('chui_user');
  };

  return (
    <Router>
      <Layout user={user} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing-methodology" element={<PricingMethodology />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/apply" element={<ApplicationWizard />} />
          
          {/* Internal Access */}
          <Route path="/login" element={user ? (user.role === 'ADMIN' ? <Navigate to="/portal/admin" /> : <Navigate to="/" />) : <Login onLogin={handleLogin} />} />
          
          {/* Admin Portal - Strictly restricted to Sales Directors / Admins */}
          <Route 
            path="/portal/admin" 
            element={user && user.role === 'ADMIN' ? <PortalAdmin user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} 
          />

          {/* Legal Pages */}
          <Route path="/terms" element={<LegalPage title="Terms of Service" content={<TermsContent />} />} />
          <Route path="/privacy" element={<LegalPage title="Privacy Policy" content={<PrivacyContent />} />} />
          <Route path="/complaints" element={<LegalPage title="Disputes & Complaints" content={<DisputesContent />} />} />
          <Route path="/collections" element={<LegalPage title="Fair Treatment" content={<StewardshipContent />} />} />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;